export const SourceType = {
    DISPRZ: 1,
    DISPRZ_ATOMIC_SKILLS: 5,
    NICE_FRAMEWORK: 2,
    SFIA_V7: 3,
    SINGAPORE_SKILLS_FUTURE: 4
};